// 模板 19：建筑设计与工程咨询公司官网

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '城市与空间的创意设计',
        content:
          '从规划到建筑，为城市与社区提供兼具美学与功能的空间解决方案。'
      },
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '全过程工程咨询',
        content:
          '为项目提供从前期策划到施工管理的全流程服务。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '项目与文档管理平台',
      subtitle: '/ Project Management',
      paragraphs: [
        '集中管理项目进度、图纸与文档，提升协作效率。',
        '便于多专业团队协同工作，保障项目质量与进度。'
      ],
      buttonText: '了解服务'
    },
    contact: {
      title: '值得信赖的设计与工程伙伴',
      subTitle: '为每一个项目注入长期价值',
      buttonText: '与我们联系'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '远象建筑设计咨询有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__聚焦城市更新与商业空间设计，提供从规划概念到施工落地的一体化设计服务。',
      '我们相信建筑不仅是空间，更是人与环境关系的载体。'
    ]
  },
  news: [
    {
      id: 'AR01',
      title: '某城市更新项目概念方案发布',
      introduce:
        '通过公共空间与商业业态的重组，为老城区注入新的活力。',
      date: '09-06',
      year: '2024'
    },
    {
      id: 'AR02',
      title: '多项设计作品获得行业奖项',
      introduce:
        '在商业综合体与办公空间等多个类别中获奖。',
      date: '05-18',
      year: '2024'
    },
    {
      id: 'AR03',
      title: '参与绿色建筑标准研讨',
      introduce:
        '在节能与可持续材料应用等方面分享设计实践。',
      date: '11-27',
      year: '2023'
    },
    {
      id: 'AR04',
      title: 'BIM 协同设计平台上线使用',
      introduce:
        '提升多专业协同效率，降低施工阶段变更风险。',
      date: '07-02',
      year: '2023'
    },
    {
      id: 'AR05',
      title: '发布年度设计作品集',
      introduce:
        '精选年度代表项目，展示设计理念与落地细节。',
      date: '03-15',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '项目协同与文档管理系统',
      sections: [
        {
          heading: '1. 项目进度跟踪',
          content:
            '按照阶段管理项目进度，清晰展示关键里程碑。'
        },
        {
          heading: '2. 图纸与文档管理',
          content:
            '集中管理图纸版本与设计说明，避免信息混乱。'
        },
        {
          heading: '3. 设计变更记录',
          content:
            '记录每一次变更的原因与影响，便于追溯。'
        },
        {
          heading: '4. 跨专业协同',
          content:
            '建筑、结构与机电等多专业团队协同工作。'
        }
      ]
    },
    bigData: {
      title: '项目数据与质量分析',
      sections: [
        {
          heading: '1. 项目周期分析',
          desc:
            '统计不同类型项目的平均设计周期与变更频次。'
        },
        {
          heading: '2. 质量问题统计',
          desc:
            '记录施工反馈的设计问题，为后续优化提供依据。'
        },
        {
          heading: '3. 资源投入分析',
          desc:
            '分析设计师投入工时与产出，优化团队配置。'
        },
        {
          heading: '4. 客户满意度反馈',
          desc:
            '收集客户与合作方评价，指导服务改进。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '规划与城市设计',
      engTitle: 'Urban Planning',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '建筑方案设计',
      engTitle: 'Architecture Design',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '室内与景观设计',
      engTitle: 'Interior & Landscape',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '工程咨询与项目管理',
      engTitle: 'Engineering Consulting',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '建筑方案设计师',
    responsibilities: [
      '参与项目概念方案与扩初设计；',
      '与结构、机电等专业配合，保证方案可实施性；',
      '参与方案汇报与客户沟通。'
    ],
    requirements: [
      '建筑学或相关专业背景，有一定项目经验；',
      '具备良好的空间想象力与审美能力；',
      '熟练使用常用设计软件，具备团队协作意识。'
    ],
    buttonText: '投递作品集'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-19.js